import CiroCard from "../shared/CiroCard";
import CiroButton, { CiroButtonStyleEnum } from "../shared/CiroButton";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

interface IManageTeamCard {
  totalPaidLicenses: number;
  totalUserAccounts: number;
}

export const ManageTeamCard = ({
  totalPaidLicenses,
  totalUserAccounts,
}: IManageTeamCard) => {
  const navigate = useNavigate();
  const overLicenseCount = totalUserAccounts > totalPaidLicenses;

  return (
    <CiroCard size="small">
      <div className={classNames("flex", "items-center", "justify-between")}>
        <div>
          <h2 className={classNames("font-semibold")}>Team</h2>
          <span
            className={classNames("text-sm font-semibold mr-1", {
              "text-green-600": !overLicenseCount,
              "text-red-600": overLicenseCount,
            })}
          >
            {totalUserAccounts} / {totalPaidLicenses}
          </span>
          <span className={classNames("text-sm")}>Ciro licenses</span>
        </div>
        <CiroButton
          analyticsField="Navigate to manage team page"
          style={CiroButtonStyleEnum.PRIMARY}
          onClick={() => navigate("/profile/team")}
        >
          Manage team
        </CiroButton>
      </div>
    </CiroCard>
  );
};
